import { g as s, a as r } from "./__packages__deps__getCurrentProduct-c133e537.js";
import { c, a as u, i as l } from "./__packages__deps__validate-customization-2bfb56fe.js";
import { r as m, c as d } from "./__packages__deps__web-929faed1.js";
import "./__packages__deps__queryProductByHandle-018098bd.js";
const i = document.querySelector("[data-render-on='pdp']"), f = () => (d(() => {
  if (s() && i) {
    const e = r();
    if (e && e.some((t) => {
      const o = c()[t], n = window.customizationProduct.availableCustomizations[t];
      return o ? n && u(o) && l(o) : !1;
    })) {
      const t = i.classList;
      t == null || t.remove("tw-hidden");
    }
  }
}), null), a = document.getElementById("validate-customization-button");
a && m(f, a);
